import React, { useEffect } from 'react';

const CANONICAL = 'https://trackntone.com';

/** Absolute URLs for TracknTone legal docs (canonical site). */
export const TRACKNTONE_LEGAL = {
  privacy: `${CANONICAL}/privacy`,
  terms: `${CANONICAL}/terms`,
  subscription: `${CANONICAL}/subscription`,
  deleteAccount: `${CANONICAL}/delete-account`,
};

/**
 * Hard redirect to an absolute URL (replaces history entry).
 * Used so northhawks.ca never serves stale TracknTone legal copy.
 */
export default function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <main style={{ padding: '3rem 1.5rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <p>
        Redirecting to{' '}
        <a href={to}>{to}</a>
        …
      </p>
    </main>
  );
}
